import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FINANCIAL_ASSISTANCE_GROUPS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/financialAssistance/constants.ts';
import { FinancialAssistanceGroup } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/financialAssistance/FinancialAssistanceGroup.tsx';
import type { IFinancialAssistanceSectionProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/financialAssistance/types.ts';
import { useDocumentGenerationOptions } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/hooks/useDocumentGenerationOptions.ts';
import type { TFinancialConditionFormValues } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const FinancialAssistanceSection: React.FC<IFinancialAssistanceSectionProps> = ({
  disabled,
}) => {
  const { watch } = useFormContext<TFinancialConditionFormValues>();
  const borrowerType = watch('borrowerType')?.value;
  const { currencyOptions, isCurrenciesLoading } = useDocumentGenerationOptions();

  if (!borrowerType) {
    return null;
  }

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        4. Інформація Позичальника про надані/отримані фінансові допомоги
      </Typography>

      {FINANCIAL_ASSISTANCE_GROUPS.map((group) => (
        <FinancialAssistanceGroup
          key={group.name}
          {...group}
          disabled={disabled}
          currencyOptions={currencyOptions}
          isCurrenciesLoading={isCurrenciesLoading}
        />
      ))}
    </Box>
  );
};
